import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import * as casesActions from '../../../../../../state/cases/cases.actions';
import * as casesSelectors from '../../../../../../state/cases/cases.selectors';
import * as clientProductsActions from '../../../../../../state/client-products/client-products.actions';
import * as clientProductsSelectors from '../../../../../../state/client-products/client-products.selectors';
import * as opportunitiesActions from '../../../../../../state/opportunities/opportunities.actions';
import * as opportunitiesSelectors from '../../../../../../state/opportunities/opportunities.selectors';
import * as partiesActions from '../../../../../../state/parties/parties.actions';
import * as partiesSelectors from '../../../../../../state/parties/parties.selectors';
import * as teamActions from '../../../../../../state/team/team.actions';
import * as teamSelectors from '../../../../../../state/team/team.selectors';

const partyRoleConfig = {
    get: partiesSelectors.getTeamMembersForPartyRole,
    loading: partiesSelectors.getTeamMembersForPartyRoleIsLoadingList,
    error: partiesSelectors.getTeamMembersForPartyRoleHasLoadingListError,
    getDispatch: partiesActions.getTeamMembersForPartyRole,
    getDispatchKey: 'partyRoleId',
    deleteTeamMember: partiesActions.deleteTeamMemberForPartyRole,
    deleteTeamMemberSuccess: partiesActions.deleteTeamMemberForPartyRoleSuccess,
    deleteTeamMemberFailure: teamActions.deleteTeamMemberFailure,
    deleteTypeKeyProp: 'memberId',
};

const partyConfig = {
    get: partiesSelectors.getTeamMembersForParty,
    loading: partiesSelectors.getTeamMembersForPartyIsLoadingList,
    error: partiesSelectors.getTeamMembersForPartyHasLoadingListError,
    getDispatch: partiesActions.getTeamMembersForParty,
    getDispatchKey: 'partyId',
    deleteTeamMember: partiesActions.deleteTeamMemberForParty,
    deleteTeamMemberSuccess: partiesActions.deleteTeamMemberForPartySuccess,
    deleteTeamMemberFailure: teamActions.deleteTeamMemberFailure,
    deleteTypeKeyProp: 'memberId',
};

export const TEAM_MEMBERS_STATE = {
    [SystemEntity.Adviser]: partyRoleConfig,
    [SystemEntity.Client]: partyRoleConfig,
    [SystemEntity.Intermediary]: partyRoleConfig,
    [SystemEntity.PartyRole]: partyRoleConfig,
    [SystemEntity.ProductProvider]: partyRoleConfig,

    [SystemEntity.Construct]: partyConfig,
    [SystemEntity.Organisation]: partyConfig,
    [SystemEntity.Party]: partyConfig,
    [SystemEntity.Person]: partyConfig,

    [SystemEntity.Case]: {
        get: casesSelectors.getAssignedTeamMembersForCase,
        loading: partiesSelectors.getTeamMembersForPartyRoleIsLoadingList,
        error: partiesSelectors.getTeamMembersForPartyRoleHasLoadingListError,
        getDispatch: casesActions.getAllMembers,
        getDispatchKey: 'caseId',
        deleteTeamMember: casesActions.deleteTeamMember,
        deleteTeamMemberSuccess: casesActions.deleteTeamMemberSuccess,
        deleteTeamMemberFailure: teamActions.deleteTeamMemberFailure,
        deleteTypeKeyProp: 'memberId',
    },
    [SystemEntity.ClientProduct]: {
        get: clientProductsSelectors.getMembersForId,
        loading: clientProductsSelectors.getMembersForIdIsLoadingList,
        error: clientProductsSelectors.getMembersForIdHasLoadingListError,
        getDispatch: clientProductsActions.getMembersForId,
        getDispatchKey: 'id',
        getInitialiseKey: 'clientProductId',
        deleteTeamMember: clientProductsActions.deleteTeamMember,
        deleteTeamMemberSuccess: clientProductsActions.deleteTeamMemberSuccess,
        deleteTeamMemberFailure: teamActions.deleteTeamMemberFailure,
        deleteTypeKeyProp: 'memberId',
    },
    [SystemEntity.Opportunity]: {
        get: opportunitiesSelectors.getAssignedTeamMembersForOpps,
        loading:
            opportunitiesSelectors.getAssignedTeamMembersForOppsIsLoadingPage,
        error: opportunitiesSelectors.getAssignedTeamMembersForOppsHasLoadingPageError,
        getDispatch: opportunitiesActions.getAllMembers,
        getDispatchKey: 'opportunityId',
        deleteTeamMember: opportunitiesActions.deleteTeamMember,
        deleteTeamMemberSuccess: opportunitiesActions.deleteTeamMemberSuccess,
        deleteTeamMemberFailure: teamActions.deleteTeamMemberFailure,
        deleteTypeKeyProp: 'memberId',
    },
    [SystemEntity.Team]: {
        get: teamSelectors.getTeamMembersForId,
        loading: teamSelectors.getTeamMembersForIdIsLoading,
        error: teamSelectors.getTeamMembersForIdHasLoadingError,
        getDispatch: teamActions.getTeamMembersForId,
        getDispatchKey: 'teamId',
        deleteTeamMember: teamActions.deleteTeamMember,
        deleteTeamMemberSuccess: teamActions.deleteTeamMemberSuccess,
        deleteTeamMemberFailure: teamActions.deleteTeamMemberFailure,
        deleteTypeKeyProp: 'memberId',
    },
};
